
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"64","height":"64","fill":"#3D2562","rx":"8.258"}}),_c('path',{attrs:{"fill":"#FFF","d":"M21.333 42.667A2.667 2.667 0 0024 45.333h16a2.667 2.667 0 002.667-2.666V21.333A2.667 2.667 0 0040 18.667h-9.56c-.71 0-1.392.282-1.893.786L22.12 25.88a2.67 2.67 0 00-.787 1.893v14.894zm12-3.334a.666.666 0 01-.666.667H26a.667.667 0 01-.667-.667V38c0-.368.299-.667.667-.667h6.667c.368 0 .666.299.666.667v1.333zM38.667 34a.667.667 0 01-.667.667H26a.667.667 0 01-.667-.667v-1.333c0-.369.299-.667.667-.667h12c.368 0 .667.298.667.667V34zM23.76 28l6.907-6.907v5.574c0 .736-.597 1.333-1.334 1.333H23.76z"}})])])
          )
        }
      }
    